


import { useEffect, useState } from "react";
import OrderCardsComp from "./OrderCardsComp";
// import TicketsManage from "./TicketsManage";
// import GuardsManage from "./GuardsManage";
// import { BaseUrl } from "../../helper/apiHelper";
import axios from "axios";
import { getDashboardDetailsApi } from "../../helper/api_helper";
const DashboardComp = () => {
    const [products, setProducts] = useState([]);

    const [stallModelInquiry, setStallModelInquiry] = useState(null)
    const [totalCorporateInquiry, setTotalCorporateInquiry] = useState(null)
    const [totalSponsorsInquiry, setTotalSponsorsInquiry] = useState(null)
    const [totalTicketBooked, setTotalTicketBooked] = useState(null)

    const [pricingDetails, setPricingDetails] = useState([])
    const [guardDetails, setGuardDetails] = useState([])
    const [isLoading, setIsLoading] = useState(false)






    const [dashboardDetails, setDashboardDetails] = useState([])
    const [supportData, setSupportData] = useState([])

    const getAdminDashboardDetails = async () => {
        try {
            setIsLoading(true)
            let response = await getDashboardDetailsApi()
            
            const dashData = response?.data
            // setStallModelInquiry(dashData?.StallModelInquiry || 0)
            // setTotalCorporateInquiry(dashData?.TotalCorporateInquiry || 0)/
            // setTotalSponsorsInquiry(dashData?.TotalSponsorsInquiry || 0)
            // setTotalTicketBooked(dashData?.TotalTicketBooked || 0)

            // setPricingDetails(dashData?.PricingDetails || [])
            // setGuardDetails(dashData?.GuardDetails || [])

            setDashboardDetails(dashData || [])

        } catch (error) {

        }

        finally {
            setIsLoading(false)
        }
    }





    useEffect(() => {
        getAdminDashboardDetails()
    }, [])









    return (
        // <div className='row gy-4'>
        //     <OrderCardsComp isLoading={isLoading}  dashboardDetails={dashboardDetails}/>





        // </div>

            <div className='position-relative' style={{ minHeight: '300px' }}>
            {isLoading ? (
                <div className='d-flex justify-content-center align-items-center w-100 h-100 position-absolute top-0 start-0 bg-white bg-opacity-75'>
                    <div className='spinner-border text-primary' role='status'>
                        <span className='visually-hidden'>Loading...</span>
                    </div>
                </div>
            ) : (
                <div className='row gy-4'>
                    <OrderCardsComp dashboardDetails={dashboardDetails} />
                </div>
            )}
        </div>
    );
};

export default DashboardComp;
